import {constantRoutes} from '@/router'
import Layout from '@/layout/index'
import {toCamelCase} from "@/utils";

const mainModule = [
  {
    menuid: 1,
    menuname: "运营中心",
    hasThird: null,
    url: "/property/property-management",
    menus: [
      {
        menuid: 11,
        menuname: "运营概况",
        hasThird: "N",
        url: "/operational-overview",
        img:require('@/assets/img/index (15).png'),
        menus: null,
      },
      {
        menuid: 12,
        menuname: "车场管理",
        hasThird: "N",
        url: "/yard-management/index",
        img:require('@/assets/img/index (1).png'),
        menus: null,
      },
      {
        menuid: 13,
        menuname: "特定车辆",
        hasThird: "N",
        url: "/specific-vehicle/black-list",
        img:require('@/assets/img/index (2).png'),
        menus: null,
      },
      {
        menuid: 14,
        menuname: "停车记录",
        hasThird: "N",
        url: "/parking-record/parking-order",
        img:require('@/assets/img/index (4).png'),
        menus: null,
      },
      {
        menuid: 15,
        menuname: "包期管理",
        hasThird: "N",
        url: "/package-period/package-handle",
        img:require('@/assets/img/index (14).png'),
        menus: null,
      },
      {
        menuid: 16,
        menuname: "欠费管理",
        hasThird: "N",
        url: "/arrears-management/arrears-vehicle",
        img:require('@/assets/img/index (10).png'),
        menus: null,
      },
      // {
      //   menuid: 17,
      //   menuname: "优惠卷",
      //   hasThird: "N",
      //   url: "/",
      //   img:require('@/assets/img/index (12).png'),
      //   menus: null,
      // },
      {
        menuid: 18,
        menuname: "人员管理",
        hasThird: "N",
        url: "/personnel/all",
        img:require('@/assets/img/index (11).png'),
        menus: null,
      },
      {
        menuid: 19,
        menuname: "数据分析",
        hasThird: "N",
        url: "/data-analysis/traffic-volume",
        img:require('@/assets/img/index (3).png'),
        menus: null,
      },
      {
        menuid: 20,
        menuname: "车场订单",
        hasThird: "N",
        url: "/report-forms/parking",
        img:require('@/assets/img/index (5).png'),
        menus: null,
      },
    ],
  },

  {
    menuid: 3,
    icon: "icon-zhuye",
    menuname: "客服管理",
    hasThird: "N",
    url: "/carpark/yard-management",
    menus: [
      {
        menuid: 31,
        menuname: "反馈建议",
        hasThird: "N",
        url: "/customer-service/user-feedback",
        img:require('@/assets/img/index (7).png'),
        menus: null,
      },
    ]
  },
  {
    menuid: 4,
    icon: "icon-zhuye",
    menuname: "财务中心",
    hasThird: "N",
    menus: [
      {
        menuid: 41,
        menuname: "账单记录",
        hasThird: "N",
        url: "/report-forms/payment-order",
        img:require('@/assets/img/index (5).png'),
        menus: null,
      },
      {
        menuid: 42,
        menuname: "收款统计",
        hasThird: "N",
        url: "/report-forms/collection-statistics",
        img:require('@/assets/img/index (8).png'),
        menus: null,
      },
    ]
  },
  {
    menuid: 5,
    icon: "icon-zhuye",
    menuname: "运维中心",
    hasThird: "N",
    url: "/personnel/all",
    menus:
      [
        {
          menuid: 51,
          menuname: "设备管理",
          hasThird: "N",
          url: "/device/index",
          img: require('@/assets/img/index (6).png'),
          menus: null,
        },
        {
          menuid: 52,
          menuname: "工单管理",
          hasThird: "N",
          url: "/order/repairs",
          img: require('@/assets/img/index (13).png'),
          menus: null,
        },
        {
          menuid: 52,
          menuname: "云岗亭",
          hasThird: "N",
          url: "/parkingdata",
          img: require('@/assets/img/index (16).png'),
          menus: null,
        },
      ]
  }
]

const leftNav = [
  {
    menuid: 1,
    icon: "icon-tingchechang",
    menuname: "停车场库",
    hasThird: null,
    url: null,
    menus: [
      {
        menuid: 1,
        icon: "icon-tingchequguanli",
        menuname: "车场管理",
        hasThird: "N",
        url: "yard-management/index",
        menus: null,
      },
      {
        menuid: 1,
        icon: "icon-icon_chedaobaochi",
        menuname: "车道管理",
        hasThird: "N",
        url: "yard-management/lane",
        menus: null,
      },
      {
        menuid: 1,
        icon: "icon-chewei",
        menuname: "车位管理",
        hasThird: "N",
        url: "yard-management/parking-space",
        menus: null,
      },
      {
        menuid: 1,
        icon: "icon-chewei1",
        menuname: "区块管理",
        hasThird: "N",
        url: "yard-management/block-management",
        menus: null,
      },
    ],
  },
  {
    menuid: 1,
    icon: "icon-shoufeipeizhi-01",
    menuname: "收费配置",
    hasThird: null,
    url: null,
    menus: [
      {
        menuid: 1,
        icon: "icon-shoufeiguize1",
        menuname: "收费规则",
        hasThird: "N",
        url: "charge-allocation/charging-rules",
        menus: null,
      },
    ],
  },
  {
    menuid: 2,
    icon: "icon-heimingdan",
    menuname: "黑名单车辆",
    hasThird: null,
    url: "specific-vehicle/black-list",
    menus: null,
  },
  {
    menuid: 2,
    icon: "icon-yumingbaimingdan",
    menuname: "白名单车辆",
    hasThird: null,
    url: "specific-vehicle/white-list",
    menus: null,
  },
  {
    menuid: 2,
    icon: "icon--cheliang",
    menuname: "车辆管理",
    hasThird: null,
    url: "specific-vehicle/vehicle-management",
    menus: null,
  },
  {
    menuid: 2,
    icon: "icon-cheliangleixing1",
    menuname: "车辆类型",
    hasThird: null,
    url: "specific-vehicle/vehicle-type",
    menus: null,
  },
  {
    menuid: 3,
    icon: "icon-chezhongxinnianjian",
    menuname: "停车订单",
    hasThird: null,
    url: "parking-record/parking-order",
    menus: null,
  },
  {
    menuid: 3,
    icon: "icon-zaitingcheliang",
    menuname: "在停车辆",
    hasThird: null,
    url: "parking-record/parking-vehicle",
    menus: null,
  },

  {
    menuid: 4,
    icon: "icon-baoqicheweiguanli",
    menuname: "包期办理",
    hasThird: null,
    url: "package-period/package-handle",
    menus: null,
  },
  {
    menuid: 4,
    icon: "icon-baoqi",
    menuname: "包期规则",
    hasThird: null,
    url: "package-period/package-rule",
    menus: null,
  },
  {
    menuid: 4,
    icon: "icon-dingdan",
    menuname: "包期订单",
    hasThird: null,
    url: "package-period/warranty-order",
    menus: null,
  },

  {
    menuid: 5,
    icon: "icon-qianfeizhangdan",
    menuname: "疑似欠费车辆",
    hasThird: null,
    url: "arrears-management/arrears-vehicle",
    menus: null,
  },
  // {
  //   menuid: 5,
  //   icon: "li-icon-xitongguanli",
  //   menuname: "欠费记录",
  //   hasThird: null,
  //   url: "arrears-management/Arrears-record",
  //   menus: null,
  // },
  {
    menuid: 6,
    icon: "icon-yidongyunkongzhitaiicon45",
    menuname: "人员管理",
    hasThird: null,
    url: "personnel/all",
    menus: null,
  },
  {
    menuid: 6,
    icon: "icon-jiaoseguanli",
    menuname: "角色管理",
    hasThird: null,
    url: "personnel/role",
    menus: null,
  },
  {
    menuid: 7,
    icon: "icon-cheliuliangfenxi_cheliuliangtongjifenxi",
    menuname: "车流量",
    hasThird: null,
    url: "data-analysis/traffic-volume",
    menus: null,
  },
  {
    menuid: 8,
    icon: "icon-icon_pushushuchu",
    menuname: "泊车订单",
    hasThird: null,
    url: "report-forms/parking",
    menus: null,
  },
  {
    menuid: 8,
    icon: "icon-tingchedingdanliebiao",
    menuname: "预定车位订单",
    hasThird: null,
    url: "report-forms/predetermine",
    menus: null,
  },
  {
    menuid: 11,
    icon: "icon-feedback",
    menuname: "用户反馈",
    hasThird: null,
    url: "customer-service/user-feedback",
    menus: null,
  },

  {
    menuid: 21,
    icon: "icon-zhifujilu",
    menuname: "支付记录",
    hasThird: null,
    url: "report-forms/payment-order",
    menus: null,
  },
  {
    menuid: 21,
    icon: "icon-tuikuanjilu1",
    menuname: "退款记录",
    hasThird: null,
    url: "report-forms/refund-order",
    menus: null,
  },
  {
    menuid: 21,
    icon: "icon-exit",
    menuname: "出场支付记录",
    hasThird: null,
    url: "report-forms/appearance-payment",
    menus: null,
  },
  {
    menuid: 21,
    icon: "icon-baoqiguanli",
    menuname: "包期支付记录",
    hasThird: null,
    url: "report-forms/guaranteed-payment",
    menus: null,
  },
  {
    menuid: 21,
    icon: "icon-kejian",
    menuname: "预约车位记录",
    hasThird: null,
    url: "report-forms/advance-payment",
    menus: null,
  },
  {
    menuid: 22,
    icon: "icon-shoukuantongji",
    menuname: "收款统计",
    hasThird: null,
    url: "report-forms/collection-statistics",
    menus: null,
  },
  // {
  //   menuid: 71,
  //   icon: "li-icon-xitongguanli",
  //   menuname: "车场",
  //   hasThird: null,
  //   url: "data-analysis/car-park",
  //   menus: null,
  // },
  // {
  //   menuid: 71,
  //   icon: "li-icon-xitongguanli",
  //   menuname: "车道",
  //   hasThird: null,
  //   url: "data-analysis/lane",
  //   menus: null,
  // },

  {
    menuid: 31,
    icon: "icon-tingchequguanli",
    menuname: "停车场设备",
    hasThird: null,
    url: null,
    menus: [
      {
        menuid: 31,
        icon: "icon-shebeiguanli",
        menuname: "设备管理",
        hasThird: "N",
        url: "device/index",
        menus: null,
      },
    ],
  },
  {
    menuid: 32,
    icon: "icon-baoxiugongdan",
    menuname: "工单管理",
    hasThird: null,
    url: null,
    menus: [
      {
        menuid: 32,
        icon: "icon-baoxiugongdan1",
        menuname: "报修工单",
        hasThird: "N",
        url: "order/repairs",
        menus: null,
      },
      {
        menuid: 32,
        icon: "icon-caozuojilu-05",
        menuname: "操作记录",
        hasThird: "N",
        url: "order/park-car",
        menus: null,
      },
      {
        menuid: 32,
        icon: "icon-a-ercisaomachengben1x",
        menuname: "二次扫码记录",
        hasThird: null,
        url: "parking-record/second-scan",
        menus: null,
      },
      {
        menuid: 33,
        icon: "icon-a-ercisaomachengben1x",
        menuname: "二次扫码记录",
        hasThird: null,
        url: "parking-record/second-scan",
        menus: null,
      },
    ],
  },
  {
    menuid: 150,
    icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
    menuname: "图表",
    hasThird: null,
    url: null,
    menus: [
      {
        menuid: 159,
        icon: "icon-provider-manage",
        menuname: "数据可视化",
        hasThird: "N",
        url: "charts/statistics",
        menus: null,
      },
    ],
  },
]

const permission = {
  state: {
    routes: [],
    addRoutes: [],
    sidebarRouters: [],
    mainMenuModuleUrl:'',
    sidebarRoutersMap: {}, // 左侧边菜单的路由，被 Sidebar/index.vue 使用
    topbarRouters: [], // 顶部菜单的路由，被 TopNav/index.vue 使用
    mainModuleRouters: [], //大模块的路由，用于左侧菜单
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    SET_DEFAULT_ROUTES: (state, routes) => {
      state.defaultRoutes = constantRoutes.concat(routes)
    },
    SET_TOPBAR_ROUTES: (state, routes) => {
      state.topbarRouters = routes
    },
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes
    },
    SET_MAIN_MENU_MODULE_ACTIVE_URL: (state, mainMenuModuleUrl) => {
      state.mainMenuModuleUrl = mainMenuModuleUrl
    },
    SET_SIDEBAR_ROUTERS_MAP: (state, routes) => {
      state.sidebarRoutersMap = routes
    },
    SET_MAIN_MODULE_ROUTERS: (state, routes) => {
      state.mainModuleRouters = routes
    },
  },
  actions: {
    /**
     * 生成路由
     *
     * @param commit commit 函数
     * @param menus  路由参数
     */
    GenerateRoutes({commit}, menus) {
      return new Promise(resolve => {
        // 将 menus 菜单，转换为 route 路由数组
        // const sdata = JSON.parse(JSON.stringify(menus)) // 【重要】用于菜单中的数据
        // const rdata = JSON.parse(JSON.stringify(menus)) // 用于最后添加到 Router 中的数据
        const mdata = JSON.parse(JSON.stringify(menus))
        const mainModuleMap = filterMainModule(mdata);
        const mainModuleRoutes = mainModuleMap.mainModuleArray;
        const mainModuleSubArray = mainModuleMap.mainModuleSubArray;
        const mainModuleSubCopyArray = JSON.parse(JSON.stringify(mainModuleSubArray))
        const sidebarRoutes = filterAsyncRouter(mainModuleSubArray)
        const sidebarRoutesMap = {};
        sidebarRoutes.map(item => {
          sidebarRoutesMap[item.name] = item.children;
        })
        const rewriteRoutes = filterAsyncRouter(mainModuleSubCopyArray, false, true)
        for (const rewriteRoute of rewriteRoutes) {
          for (const mainModuleRoute of mainModuleRoutes) {
            if (mainModuleRoute.menus && mainModuleRoute.menus.length) {
              mainModuleRoute.menus.forEach(sub => {
                if (sub.componentName === rewriteRoute.name) {
                  if (rewriteRoute.children && rewriteRoute.children.length) {
                    let subRewriteRoute = rewriteRoute.children[0]
                    if(subRewriteRoute.children && subRewriteRoute.children.length) {
                      sub.url = subRewriteRoute.children[0].path;
                    } else {
                      sub.url = subRewriteRoute.path;
                    }
                  }
                }
              })
            }
          }
        }
        rewriteRoutes.push({path: '*', redirect: '/404', hidden: true})
        commit('SET_ROUTES', rewriteRoutes)
        commit('SET_SIDEBAR_ROUTERS_MAP', sidebarRoutesMap)
        commit('SET_DEFAULT_ROUTES', sidebarRoutesMap)
        commit('SET_TOPBAR_ROUTES', sidebarRoutesMap)
        commit('SET_MAIN_MODULE_ROUTERS', mainModuleRoutes)
        resolve(rewriteRoutes)
      })
    }
  }
}

function filterMainModule(asyncRouterMap) {
  const mainModuleSubArray = [];
  let index = 1;
  const mainModuleArray = asyncRouterMap.filter(route => route.type === 9)
    .map(ele => {
      let obj = {
        menuid: index++,
        icon: "icon-zhuye",
        menuname: ele.name,
        componentName: ele.componentName,
        hasThird: "N",
      }
      if (ele.children && ele.children.length > 0) {
        obj.menus = ele.children.map(sub=>{
          let subObj = {
            menuid: index++,
            menuname: sub.name,
            componentName: sub.componentName,
            hasThird: "N",
            url : ele.path + '/' + sub.path
          }
          if (sub.icon && sub.icon !== '#') {
            subObj.img = require('@/assets/img/'+sub.icon)
          }
          if (sub.children && sub.children.length > 0) {
            sub.path = subObj.url;
            mainModuleSubArray.push(sub);
          }
          return subObj;
        })
      }
      return obj;
    })
  return {
    mainModuleArray: mainModuleArray,
    mainModuleSubArray: mainModuleSubArray
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    // 将 ruoyi 后端原有耦合前端的逻辑，迁移到此处
    // 处理 meta 属性
    route.meta = {
      title: route.name,
      icon: route.icon,
      noCache: !route.keepAlive,
    }
    route.hidden = !route.visible
    // 处理 name 属性
    if (route.componentName && route.componentName.length > 0) {
      route.name = route.componentName
    } else {
      // 路由地址转首字母大写驼峰，作为路由名称，适配 keepAlive
      route.name = toCamelCase(route.path, true)
      // 处理三级及以上菜单路由缓存问题，将 path 名字赋值给 name
      if (route.path.indexOf("/") !== -1) {
        const pathArr = route.path.split("/");
        route.name = toCamelCase(pathArr[pathArr.length - 1], true)
      }
    }
    if (lastRouter) {
      route.path = lastRouter.path + '/' + route.path
    }
    route.componentName = route.meta.title;
    // 处理 component 属性
    if (route.children) { // 父节点
    //   if (isFirst) {
        route.component = Layout
      //   isFirst = false;
      // } else {
      //   route.component = ParentView
      // }
    } else { // 根节点
      if (route.component) {
        route.component = loadView(route.component)
      }
    }

    // filterChildren
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
      route.alwaysShow = route.alwaysShow !== undefined ? route.alwaysShow  : true
    } else {
      delete route['children']
      delete route['alwaysShow'] // 如果没有子菜单，就不需要考虑 alwaysShow 字段
    }
    return true
  })
}

function filterChildren(childrenMap, lastRouter = false) {
  let children = [];
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (!el.component && !lastRouter) {
        el.children.forEach(c => {
          c.path = el.path + '/' + c.path
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c))
            return
          }
          children.push(c)
        })
        return
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    children = children.concat(el)
  })
  return children
}

export const loadView = (view) => { // 路由懒加载
  return (resolve) => require([`@/views/${view}`], resolve)
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js